import { VisaPurposeServerValues } from 'constant';

const PURPOSE_GENERAL_KEYS = new Set(['NOPREFERENCE', 'ALL', 'ALLVISAS']);

/**
 * Maps UI / legacy Purpose values to the backend `Purpose.purpose` string.
 * "No preference" / "All visas" is stored as General (`GENERAL`).
 */
export function toPurposeServerValue(purpose: string): string {
    const key = purpose
        .trim()
        .toUpperCase()
        .replace(/[_\s-]+/g, '');
    if (PURPOSE_GENERAL_KEYS.has(key)) {
        return VisaPurposeServerValues.NOPREFERENCE;
    }
    return purpose;
}

export function toPurposePayload<T extends object>(payload: T): T {
    if (!('purpose' in payload) || typeof payload.purpose !== 'string') {
        return payload;
    }
    return { ...payload, purpose: toPurposeServerValue(payload.purpose) };
}
